import styled from 'styled-components';

import bgFooter from '~/assets/bg-section-footer.png';
import ilustraFooter from '~/assets/ilustra-03.png';
import iconPhone from '~/assets/icon-phone.png';
import iconWhatsapp from '~/assets/icon-whatsapp.png';

export const Container = styled.footer`
  position: relative;
  background-color: #fff;
  background-image: url(${ilustraFooter});  
  background-position: 15% 90%; 
  background-repeat: no-repeat;
  padding: 120px 0 900px;
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 120px;
    margin-top: -120px;
    background: url(${bgFooter}) center top no-repeat;
      }
`;

export const Inner = styled.div`
  width: 100%;
  max-width: 1680px;
  display: flex;

  & > h2 {
    flex: 0 0 50%;
    text-align: right;
    color: #27357c;
    font-size: 60px;
    font-weight: 900;
    text-shadow: 2px 2px 0 #a8dff4;
    padding-right: 60px;
    span {
      display: block;
      text-align: right;
      color: #831d13;
    }
  }
  & > div {
    font-size: 30px;
    line-height: 57px;
    p {
      padding: 0 0 5px;
      color: #545353;
      a {
        color: #27357c;
        font-weight: 700;
        text-decoration: underline;
      }
      &.phone {
        padding-left: 55px;
        background: url(${iconPhone}) left center no-repeat;
        background-size: auto 70%;
        &.whatsapp {
          background: url(${iconWhatsapp}) left center no-repeat;
          background-size: auto 60%;
        }
      }
    }
  }
  @media (max-width: 870px) {
    flex-direction: column;
    padding-left: 15px;
    padding-right: 15px;
    & > h2 {
      text-align: left;
      padding: 0 0 35px;
      font-size: calc(100vw / 15);
      * {
        text-align: left !important;
      }
    }
    & > div {
      font-size: calc(100vw / 35);
    }
  }
  @media (max-width: 550px) {
    h2 {
      font-size: 30px;
    }
    & > div {
      font-size: 16px;
      line-height: 40px;
    }
  }
`;

export const Sign = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 0;
  right: 0;
  color: #63afe2;
  font-size: 17px;
  letter-spacing: -0.24px;
  margin: 20px;
`;
